import React from "react";
import NotificationCard from "../NotificationCard/NotificationCard";
import { NotificationCardProp } from "../NotificationCard/NotificationCard";
// import errorIcon from "../../../assets/error-icon.svg";

const ErrorCard: React.FC<NotificationCardProp> = ({
  title,
  subtitle,
  children,
  className,
  closeModal,
}) => {
  return (
    <NotificationCard
      // icon={<img src={errorIcon} alt="error-icon" />}
      icon={
        <svg
          id="Cautionicons"
          width="70"
          height="70"
          viewBox="0 0 70 70"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{maxWidth: '100%', maxHeight: '100%'}}
        >
          <g clipPath="url(#clip0_21439_183183)">
            <rect
              x="11"
              y="11"
              width="48"
              height="48"
              rx="24"
              fill="white"
              strokeDasharray="0,0,0,149.82472229003906"
            >
              <animate
                attributeType="XML"
                attributeName="strokeDasharray"
                repeatCount="1"
                dur="0.625s"
                values="0,0,0,149.82472229003906; 
                0,74.91236114501953,74.91236114501953,0; 
                149.82472229003906,0,0,0"
                keyTimes="0; 0.5; 1"
                fill="freeze"
              ></animate>
            </rect>
            <circle
              cx="24.0005"
              cy="24.0005"
              r="24.0005"
              transform="matrix(-1 8.74228e-08 8.74228e-08 1 59 11)"
              fill="#DF4B2D"
              strokeDasharray="0,0,0,149.82786560058594"
            >
              <animate
                attributeType="XML"
                attributeName="strokeDasharray"
                repeatCount="1"
                dur="0.625s"
                values="0,0,0,149.82786560058594; 
                0,74.91393280029297,74.91393280029297,0; 
                149.82786560058594,0,0,0"
                keyTimes="0; 0.5; 1"
                fill="freeze"
              ></animate>
            </circle>
            <path
              d="M28.3691 28L43 42.6309"
              stroke="#F6F7F9"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray="0,0,0,20.69121742248535"
            >
              <animate
                attributeType="XML"
                attributeName="strokeDasharray"
                repeatCount="1"
                dur="0.625s"
                values="0,0,0,20.69121742248535; 
                0,10.345608711242676,10.345608711242676,0; 
                20.69121742248535,0,0,0"
                keyTimes="0; 0.5; 1"
                fill="freeze"
              ></animate>
            </path>
            <path
              d="M43 28L28.3691 42.6309"
              stroke="#F6F7F9"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray="0,0,0,20.69121742248535"
            >
              <animate
                attributeType="XML"
                attributeName="strokeDasharray"
                repeatCount="1"
                dur="0.625s"
                values="0,0,0,20.69121742248535; 
                0,10.345608711242676,10.345608711242676,0; 
                20.69121742248535,0,0,0"
                keyTimes="0; 0.5; 1"
                fill="freeze"
              ></animate>
            </path>
          </g>
          <rect
            x="5.9"
            y="5.9"
            width="58.2"
            height="58.2"
            rx="29.1"
            stroke="#DF4B2D"
            strokeOpacity="0.28"
            strokeWidth="10.2"
            strokeDasharray="0,0,0,182.5453338623047"
          >
            <animate
              attributeType="XML"
              attributeName="strokeDasharray"
              repeatCount="1"
              dur="0.625s"
              values="0,0,0,182.5453338623047; 
                0,91.27266693115234,91.27266693115234,0; 
                182.5453338623047,0,0,0"
              keyTimes="0; 0.5; 1"
              fill="freeze"
            ></animate>
          </rect>
          <defs>
            <clipPath id="clip0_21439_183183">
              <rect
                x="11"
                y="11"
                width="48"
                height="48"
                rx="24"
                fill="white"
                strokeDasharray="0,0,0,149.82472229003906"
              >
                <animate
                  attributeType="XML"
                  attributeName="strokeDasharray"
                  repeatCount="1"
                  dur="0.625s"
                  values="0,0,0,149.82472229003906; 
                0,74.91236114501953,74.91236114501953,0; 
                149.82472229003906,0,0,0"
                  keyTimes="0; 0.5; 1"
                  fill="freeze"
                ></animate>
              </rect>
            </clipPath>
          </defs>
        </svg>
      }
      title={title}
      subtitle={subtitle}
      className={`error-card ${className}`}
      closeModal={closeModal}
      children={children}
    />
  );
};

export default ErrorCard;
